/* The Settings sub-navigation: a segmented control made of links, a soft blue-grey track with
   the current area as a white pill and a primary label (ADR 0019, ADR 0028). On narrow screens it scrolls sideways
   inside itself. */
.nav {
  max-width: 100%;
  margin-bottom: var(--space-5);
  overflow-x: auto;
}

.list {
  display: flex;
  gap: 2px;
  width: max-content;
  margin: 0;
  padding: 3px;
  border-radius: var(--radius-control);
  background: var(--wash);
  list-style: none;
}

.link {
  display: flex;
  align-items: center;
  min-height: calc(var(--control-height) - 8px);
  padding: 0 var(--space-3);
  border-radius: calc(var(--radius-control) - 2px);
  color: var(--pencil);
  font: var(--t-body);
  text-decoration: none;
  white-space: nowrap;
  transition:
    background-color var(--dur) var(--ease),
    color var(--dur) var(--ease);
}

.link:hover {
  color: var(--ink);
}

.link:focus-visible {
  outline: var(--focus-ring);
  outline-offset: -2px;
}

.link[aria-current='page'] {
  background: var(--paper);
  box-shadow: var(--shadow-pill);
  color: var(--brand);
  font-weight: 500;
}

@media (pointer: coarse) {
  .link {
    min-height: var(--touch-target);
  }
}
